import React from "react";
import { Box } from "@mui/material";
import { tokens } from "../../utils/figmaTokens";

// A key hint ("⌘ K", "Esc", "↵"): Figma's kbd chip, white with a hairline border.
const Kbd = ({ children, sx }) => (
  <Box
    component="kbd"
    sx={{
      display: "inline-flex",
      alignItems: "center",
      px: "6px",
      py: "2px",
      borderRadius: "6px",
      border: `1px solid ${tokens.border.default}`,
      bgcolor: tokens.surface.default,
      color: tokens.text.tertiary,
      fontFamily: "inherit",
      fontSize: 12,
      lineHeight: "16px",
      fontWeight: 500,
      letterSpacing: "0.2px",
      whiteSpace: "nowrap",
      ...sx,
    }}
  >
    {children}
  </Box>
);

export default Kbd;
